import { injected } from "@wagmi/connectors";
import {
  type Config,
  cookieStorage,
  createConfig,
  createStorage,
  http,
} from "@wagmi/core";
import { custom, type Transport } from "viem";
import "viem/window";
import { bsc } from "wagmi/chains";
import { EXPECTED_CHAIN } from "@/configs/expected-chain";

// Priority:
//   1) NEXT_PUBLIC_RPC_URL — ONLY when NEXT_PUBLIC_CONTRACT_NET === "FORK"
//      (explicit local Hardhat fork override; ignored in MAIN/TEST builds even
//      if the var leaks into the env)
//   2) Connected wallet's injected provider (window.ethereum)
//   3) Chain's default public RPC (SSR / no wallet / no env)
function buildPrimaryTransport(): Transport {
  const customRpc =
    process.env.NEXT_PUBLIC_CONTRACT_NET === "FORK"
      ? process.env.NEXT_PUBLIC_RPC_URL
      : undefined;
  if (customRpc) return http(customRpc);
  if (typeof window !== "undefined" && window.ethereum) {
    return custom(window.ethereum);
  }
  return http();
}

const primaryTransport = buildPrimaryTransport();

export const minimalWagmiConfig: Config = createConfig({
  chains: [EXPECTED_CHAIN, bsc],
  connectors: [injected({ target: "metaMask" }), injected()],
  transports: {
    [EXPECTED_CHAIN.id]: primaryTransport,
    [bsc.id]: http(),
  },
  storage: createStorage({
    storage: cookieStorage,
  }),
  ssr: true,
});
